// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__27fsm","container":"styles_container__1KydV","title":"styles_title__6C-98","wrapper":"styles_wrapper__ETQij","answer":"styles_answer__1w-NI"};